import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Not found · Wedding Video Essex Reviews" description="Page not found." />
      <div className="min-h-[60vh] flex items-center justify-center text-center px-6 py-32">
        <div>
          <p className="overline mb-5">404</p>
          <h1 className="font-serif text-5xl md:text-7xl text-stone-900 leading-tight">
            Page not found.
          </h1>
          <p className="mt-6 text-stone-600 max-w-md mx-auto">
            That page doesn't exist. Head back to the reviews.
          </p>
          <Link to="/" className="btn-primary mt-8 inline-flex" data-testid="not-found-home">
            Back to home
          </Link>
        </div>
      </div>
    </>
  );
}
